export default {

	data() {
		return {
			breadCrumb: [],
		}
	},

	created: function() {
		this.bounce();
	},

	methods: {

		bounce() {
			if (this.$route.meta.bounce) {
				var bounced = 0;
				if (localStorage.getItem('bounce')) {
					bounced = parseInt(localStorage.getItem('bounce'));
					bounced ++;
				}
				else {
					localStorage.setItem('bounce', 1);
				}
				if (bounced < 10) {
					localStorage.setItem('bounce', bounced);
					this.$nextTick(() => {
						setTimeout(() => {
							const contentHeight = document.getElementById('body').clientHeight;
							const windowHeight = window.innerHeight;
							const scrollableHeight = contentHeight - windowHeight;
							if (scrollableHeight > 150) {
								window.scrollTo({ top: scrollableHeight, behavior: 'smooth' });
								setTimeout(() => {
									window.scrollTo({ top: 0, behavior: 'smooth' });
								}, 500);
							}
						}, 500);
					});
				}
			}
		},
		
		_getBeginningOfPreviousYear() {
			const now = new Date();
			const previousYear = now.getFullYear() - 1;
			return new Date(previousYear, 0, 1);
		},

		_getBeginningOfLastMonth() {
			const now = new Date();
			const lastMonth = now.getMonth() - 1;
			const year = lastMonth < 0 ? now.getFullYear() - 1 : now.getFullYear();
			const month = lastMonth < 0 ? 11 : lastMonth;
			return new Date(year, month, 1);
		},

		_mergeAndSortArrays(monthsArray, yearsArray, sortBy) {
			const mergedArray = [...monthsArray, ...yearsArray];
			mergedArray.sort((a, b) => new Date(a[sortBy]) - new Date(b[sortBy]));
			return mergedArray;
		},

		_getMonthName(dateString) {
			const date = new Date(dateString);
			return date.toLocaleString('default', { month: 'long' });
		},

		_getMonthShortName(dateString) {
			const date = new Date(dateString);
			return date.toLocaleString('default', { month: 'short' });
		},

		_getYear(dateString) {
			const date = new Date(dateString);
			return date.getFullYear();
		},

		_inputControl_GoNext(onFinished = null, before = null) {
			this.validationText = '';
			var allOK = true;
			if (before) {
				if (!before()){
					return;
				}
			}
			for (const field of this.sections[this.sectionNo].fields) {
				if (field.required && (!field.value || field.value === "")) {
					this.validationText = field.validationText;
					allOK = false;
					break;
				}
				if (field.type === 'datetext' && field.value.length < 10) {
					this.validationText = "Please enter date in the format dd/mm/yyyy";
					allOK = false;
					break;
				}
				if (field.strongPass != undefined && field.strongPass == false) {
					this.validationText = "Your password is not strong enough"
					allOK = false;
					break;
				}
			}
			if (allOK) {
				var allowed = false;
				this.breadCrumb.push({ sectionNo: this.sectionNo });
				while (!allowed)
				{
					this.validationText = null;
					this.sectionNo++;
					if (!this.sections[this.sectionNo]) {
						if (onFinished) {
							onFinished();
							return;
						}
					}
					else {
						allowed = this._sectionAllowed(this.sections[this.sectionNo]);
					}
				}
				this.currentPageNumber++;
				this.$refs.inputSections.next(this.sectionNo);
			}
			setTimeout(() => { this.validationText = null }, 4000);
		},

		_inputControl_GoBack() {
			var breadCrumb = this.breadCrumb.pop();
			this.sectionNo = breadCrumb.sectionNo;
			this.validationText = null;
			this.currentPageNumber--;
			this.$refs.inputSections.back(this.sectionNo);
		},

		_sectionAllowed(section) {
			if (!section.rule) {
				return true;
			}
			const [ruleKey, ruleValue] = section.rule.split(':').map(s => s.trim());
			const ruleValues = ruleValue.split(',').map(s => s.trim());
			for (let i = 0; i < this.sectionNo; i++) {
				const section = this.sections[i];
				for (const field of section.fields) {
					if (field.id === ruleKey && ruleValues.includes(field.value)) {
						return true;
					}
				}
			}
			return false;
		},

		_preValidate() {
			this.validationText = null;
			const now = new Date();

			this.sections[this.sectionNo].fields.forEach(field => {
				if (field.type === 'datetext' && field.value) {
					const [day, month, year] = field.value.split('/');
					const date = new Date(year, month - 1, day);

					if (field.future && date < now) {
						this.validationText = `${field.label} must be in the future`;
						return false;
					}

					if (field.past && date > now) {
						this.validationText = `${field.label} must be in the past`;
						return false;
					}
				}
			});

			return !this.validationText;
		},

		_csharpDateTimetoDateTime(dateString, humanificate = true) {
			const date = new Date(dateString);
			if (humanificate) {
				const now = new Date();
				
				// Get calendar dates (ignoring time)
				const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
				const nowOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
				
				// Calculate difference in calendar days
				const diffTime = nowOnly - dateOnly;
				const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

				const options = { hour: '2-digit', minute: '2-digit' }; // Remove seconds from time

				if (diffDays === 0) {
					return "Today at " + date.toLocaleTimeString([], options);
				} else if (diffDays === 1) {
					return "Yesterday at " + date.toLocaleTimeString([], options);
				} else if (diffDays <= 7) {
					return `${diffDays} days ago at ` + date.toLocaleTimeString([], options);
				}
			}
			return date.toLocaleString([], { hour: '2-digit', minute: '2-digit', year: 'numeric', month: 'numeric', day: 'numeric' });
		},

		_stringToDate(dateString) {
			if (!dateString || dateString === 'NaN/NaN/NaN') {
				return null;
			}
			const [day, month, year] = dateString.split('/');
			const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
			return formattedDate;
		},

		_dateToString(dateString) {
			const date = new Date(dateString);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${day}/${month}/${year}`;
		},

		_findFieldValue(fieldName) {
			for (const section of this.sections) {
				for (const field of section.fields) {
					if (field.label === fieldName && field.value != null) {
						return field.value;
					}
				}
			}
			return null;
		},

		_findFieldValueById(fieldId) {
			for (const section of this.sections) {
				for (const field of section.fields) {
					if (field.id === fieldId && field.value != null) {
						return field.value;
					}
				}
			}
			return null;
		},

		_setFieldValue(fieldName, value) {
			for (const section of this.sections) {
				for (const field of section.fields) {
					if (field.label === fieldName) {
						field.value = value;
					}
				}
			}
		},

		_setFieldValueById(fieldId, value) {
			for (const section of this.sections) {
				for (const field of section.fields) {
					if (field.id === fieldId) {
						field.value = value;
					}
				}
			}
		},

		_findField(fieldName) {
			for (const section of this.sections) {
				for (const field of section.fields) {
					if (field.label === fieldName) {
						return field;
					}
				}
			}
			return null;
		},

		_removeNullProperties(obj) {
			Object.keys(obj).forEach(key => obj[key] == null && delete obj[key]);
			return obj;
		},
		
		_loadFieldsFromObject(fieldMappings) {
			Object.keys(fieldMappings).forEach(fieldName => {
				this.sections.forEach(section => {
					section.fields.forEach(field => {
						if (field.label === fieldName) {
							field.value = fieldMappings[fieldName];
						}
					});
				});
			});
		},

		_daysBetweenDates(date1, date2) {
			const oneDay = 24 * 60 * 60 * 1000;
			const firstDate = new Date(date1);
			const secondDate = new Date(date2);
			return Math.round((secondDate - firstDate) / oneDay);
		},

		_preventNegative: function(event) {
			if (event.key === '-' || event.key === 'e') {
				event.preventDefault();
			}
		},

		_checkAndRequestNotifications(returnPage = "you") {
			var asked = localStorage.getItem("notificationsRequested");
			if (!asked) {
				this._signalV1("enableNotifications", "", "", "", returnPage);
				localStorage.setItem("notificationsRequested", true);
			}
		},
		
		_formattedTransactionDate(createdDateTime) {
			const date = new Date(createdDateTime);
			if (isNaN(date)) {
				return 'Invalid Date';
			}
			const day = String(date.getDate()).padStart(2, '0');
			const month = date.toLocaleString('default', { month: 'long' });
			const year = date.getFullYear();
			return `${day} ${month}, ${year}`;
		},

		_getTextColorForBackground(bg) {
			// bg is in rgb(r,g,b) or hex
			let r, g, b;
			if (bg.startsWith('rgb')) {
				[r, g, b] = bg.match(/\d+/g).map(Number);
			} else if (bg.startsWith('#')) {
				if (bg.length === 7) {
					r = parseInt(bg.slice(1, 3), 16);
					g = parseInt(bg.slice(3, 5), 16);
					b = parseInt(bg.slice(5, 7), 16);
				}
			}
			const brightness = (r * 299 + g * 587 + b * 114) / 1000;
			return brightness > 200 ? 'var(--text-color)' : 'var(--light-text-color)';
		},

		_processMonetaryAmounts(text) {
			if (localStorage.getItem('randomiseFigures') !== 'true') {
				return text;
			}

			// Match currency symbols (£, $) followed by numbers with optional decimal places
			// Also match numbers followed by currency words (pounds, pence, etc)
			const monetaryPattern = /(?:£|$)(?:\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+(?:\.\d{2})?)|(?:\d+(?:\.\d{2})?\s*(?:pounds?|pence|p|GBP|USD))/gi;
			
			return text.replace(monetaryPattern, (match) => {
				// Replace the entire number portion with exactly 4 # characters
				// while preserving currency symbols and words
				if (match.startsWith('£') || match.startsWith('$')) {
					return match.charAt(0) + '####';
				} else {
					// For amounts with currency words, replace the number with ####
					return '####' + match.replace(/^\d+(?:\.\d{2})?/, '');
				}
			});
		},

		_deepCopy(obj) {
			return JSON.parse(JSON.stringify(obj));
		}
	}
}